import { toCamelCase, toSnakeCase } from '../utils/caseConverter';
import { Customer } from '../types/Customer';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCustomers = () => {
  return fetch(`${API_BASE_URL}/api/customers`, {
      headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`},
    }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function fetchCustomerById(customerId: number): Promise<Customer> {
  return fetch(`${API_BASE_URL}/api/customers/${customerId}`, {
      headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`},
    }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function createCustomer(data: Customer): Promise<{ id: number }> {
  const res = await fetch(`${API_BASE_URL}/api/customers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify(toSnakeCase(data)),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create customer: ${errorText}`);
  }

  return res.json();
}
